module.exports = __webpack_public_path__ + "static/media/doc_browser_gray@2x.2a8081f1.png";